import http from '@/assets/plugin/prototypes/modules/http.js'

//优惠券列表
export function listCoupon(data) {
  return http.post("coupon/list", data)
}

//兑换优惠券
export function exchangeCoupon(data) {
  return http.post("coupon/exchange", data)
}

//领取优惠券
export function drawCoupon(data) {
  return http.post("coupon/draw", data)
}

//获取我的优惠券列表
export function listMyCoupon(data) {
  return http.post("coupon/myList", data)
}



// WEBPACK FOOTER //
// ./src/api/coupon.js